/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";

// custom components
import dompurify from "dompurify";
import PageWrapper from "../PageWrapper";
import Editor from "../GenericFormikComponents/Editor";
import PrimaryButton from "../SFUCentralThemedComponents/PrimaryButton";
import InputText from "../GenericFormikComponents/InputText";
import Dropdown from "../../components/GenericFormikComponents/Dropdown";
import CheckboxPR from "../PrimeReact/CheckboxPR";
import AutoSave from "../../utils/formik/AutoSave";
import { validationSchema, initialValues } from "./validationSchema";
import ProgressSpinnerPR from "../PrimeReact/ProgressSpinnerPR";
import Label from "../Label";

export default function QuestionPage({
  goToPage,
  scholarshipAppData,
  pageInfo,
  saveField,
  saveFieldStatus,
  savePage,
  steppers,
  spinnerStatus,
}) {
  const sanitizer = dompurify.sanitize;
  const renderHeader = () => {
    return (
      <>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold" type="button" />
          <button className="ql-italic" aria-label="Italic" type="button" />
          <button
            className="ql-underline"
            aria-label="Underline"
            type="button"
          />
        </span>
        <span className="ql-formats">
          <button
            className="ql-list"
            value="ordered"
            aria-label="Ordered List"
            type="button"
          />
          <button
            className="ql-list"
            value="bullet"
            aria-label="Unordered List"
            type="button"
          />
        </span>
      </>
    );
  };

  const header = renderHeader();
  const questions = scholarshipAppData.data.questions[pageInfo.pageNum];
  const wordCounts = questions.map(function (question) {
    if (
      question.type.includes("Marginalized") ||
      !scholarshipAppData.data[
        `questionAnswer_${question.scholarship_application_answers_id}`
      ] ||
      !scholarshipAppData.data[
        `questionAnswer_${question.scholarship_application_answers_id}`
      ].replace(/<\/?[^>]+(>)/g, " ") ||
      !scholarshipAppData.data[
        `questionAnswer_${question.scholarship_application_answers_id}`
      ]
        .replace(/<\/?[^>]+(>)/g, " ")
        .match(/\S+/g)
    ) {
      return 0;
    }
    return scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}`
    ]
      .replace(/<\/?[^>]+(>)/g, " ")
      .match(/\S+/g).length;
  });
  const [wordCount, setWordCount] = useState(wordCounts);
  const [lastSaved, setLastSaved] = useState("");
  const [annualIncomeKey, setAnnualIncomeKey] = useState(null);
  const [firstAnnualIncome, setFirstAnnualIncome] = useState(null);
  const [youthInCare, setYouthInCare] = useState(null);
  const [secondAnnualIncome, setSecondAnnualIncome] = useState(null);
  const [isDropDownErrorMessage, setIsDropdownErrorMessage] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [isStringErrorMessage, setIsStringErrorMessage] = useState(false);
  const [familyCompositionKey, setFamilyCompositionKey] = useState(null);
  const [selectedFamilyComposition, setSelectedFamilyComposition] =
    useState(null);
  const [isFamilyCompositionPage, setIsFamilyCompositionPage] = useState(false);
  const [numDependentKey, setNumDependentKey] = useState(null);
  const [selectedNumDependent, setSelectedNumDependent] = useState(null);
  const [isNMarginPage, setIsMarginPage] = useState(false);
  const [isNumDependentPage, setIsNumDependentPage] = useState(false);
  const [selectedAnnualIncome, setSelectedAnnualIncome] = useState(null);
  const [selectedFirstAnnualIncome, setSelectedFirstAnnualIncome] =
    useState(null);
  const [selectedSecondAnnualIncome, setSelectedSecondAnnualIncome] =
    useState(null);

  const [savedMarginalizedGroup, setSavedMarginalizedGroup] = useState([]);

  useEffect(() => {
    // Get the previously saved answers when on the marginalized group page
    let marginalizedGroups = [];
    questions.map((question) => {
      const ANSWER_ID = question.scholarship_application_answers_id;
      if (scholarshipAppData.data[`questionAnswer_${ANSWER_ID}`] !== null) {
        marginalizedGroups.push(ANSWER_ID);
      }
    });
    setSavedMarginalizedGroup(marginalizedGroups);
  }, [isNMarginPage]);

  const onMarginalizedGroupChange = (e) => {
    let selectedMarginalizedGroups = [...savedMarginalizedGroup];
    if (e.checked) {
      selectedMarginalizedGroups.push(e.value);
    } else {
      selectedMarginalizedGroups.splice(
        savedMarginalizedGroup.indexOf(e.value),
        1
      );
    }

    setSavedMarginalizedGroup(selectedMarginalizedGroups);
  };
  const [dependentBirthYearKey, setDependentBirthYearKey] = useState(null);
  const [noDependent, setNoDependent] = useState(null);
  const [isDependentErrorMessage, setIsDependentErrorMessage] = useState(false);
  const [isDependentStringErrorMessage, setIsDependentStringErrorMessage] =
    useState(false);

  // const [numDependentDisplay, setNumDependentDisplay] = useState("none");

  let numDependentKeyArr = [];

  const autoSave = (
    <AutoSave
      savedFields={Object.keys(initialValues(questions))}
      postData={{ scholarship_app_id: 1 }}
      saveField={saveField}
      saveFieldStatus={saveFieldStatus}
      setLastSaved={setLastSaved}
    />
  );

  const familyCompositionOptions = [
    {
      label: "I live in a single-parent/guardian household",
      value: "I live in a single-parent/guardian household",
    },
    {
      label: "I live in a two-parent/guardian household",
      value: "I live in a two-parent/guardian household",
    },
    {
      label: "I am a Youth in Care, or a former Youth in Care",
      value: "I am a Youth in Care, or a former Youth in Care",
    },
  ];

  const numberOfDependentsOptions = [
    {
      label: "0",
      value: "0",
    },
    {
      label: "1",
      value: "1",
    },
    {
      label: "2",
      value: "2",
    },
    {
      label: "3",
      value: "3",
    },
    {
      label: "4",
      value: "4",
    },
    {
      label: "5",
      value: "5",
    },
    {
      label: "6",
      value: "6",
    },
    {
      label: "7",
      value: "7",
    },
    {
      label: "8",
      value: "8",
    },
    {
      label: "9",
      value: "9",
    },
    {
      label: "10",
      value: "10",
    },
  ];

  const onFamilyCompositionChange = (e, question) => {
    setSelectedFamilyComposition(e.value);

    if (
      e.value === "I live in a single-parent/guardian household" &&
      (scholarshipAppData.data[
        `questionAnswer_${question.scholarship_application_answers_id}`
      ] === "I live in a two-parent/guardian household" ||
        scholarshipAppData.data[
          `questionAnswer_${question.scholarship_application_answers_id}`
        ] === "I am a Youth in Care, or a former Youth in Care")
    ) {
      let annualIncomeFieldKey = parseInt(
        question.scholarship_application_answers_id,
        10
      );
      annualIncomeFieldKey =
        "questionAnswer_" + (annualIncomeFieldKey + 1).toString();
      scholarshipAppData.data[annualIncomeFieldKey] = null;
      setSelectedAnnualIncome(null);
    }

    scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}`
    ] = null;

    if (e.value === "" || e.value === null) {
      setIsDropdownErrorMessage(true);
    } else {
      setIsDropdownErrorMessage(false);
    }
  };

  const onNumDependentChange = (e, question) => {
    setSelectedNumDependent(e.value);
    scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}`
    ] = null;

    if (e.value === "" || e.value === null) {
      setIsDropdownErrorMessage(true);
    } else {
      setIsDropdownErrorMessage(false);
    }
  };

  const onAnnualIncomeChange = (e, question) => {
    setSelectedAnnualIncome(e.target.value);
    scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}`
    ] = null;
    if (e.target.value === "" || e.target.value === null) {
      setIsErrorMessage(true);
      setIsStringErrorMessage(false);
    } else if (!isNum(e.target.value)) {
      setIsStringErrorMessage(true);
      setIsErrorMessage(false);
    } else {
      setIsErrorMessage(false);
      setIsStringErrorMessage(false);
    }
  };

  const onFirstAnnualIncomeChange = (e, question) => {
    setSelectedFirstAnnualIncome(e.target.value);
    scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}_first`
    ] = null;
    if (e.target.value === "" || e.target.value === null) {
      setIsErrorMessage(true);
      setIsStringErrorMessage(false);
    } else if (!isNum(e.target.value)) {
      setIsStringErrorMessage(true);
      setIsErrorMessage(false);
    } else {
      setIsErrorMessage(false);
      setIsStringErrorMessage(false);
    }
  };

  const onSecondAnnualIncomeChange = (e, question) => {
    setSelectedSecondAnnualIncome(e.target.value);
    scholarshipAppData.data[
      `questionAnswer_${question.scholarship_application_answers_id}_second`
    ] = null;
    if (e.target.value === "" || e.target.value === null) {
      setIsErrorMessage(true);
      setIsStringErrorMessage(false);
    } else if (!isNum(e.target.value)) {
      setIsStringErrorMessage(true);
      setIsErrorMessage(false);
    } else {
      setIsErrorMessage(false);
      setIsStringErrorMessage(false);
    }
  };

  const isNum = (val) => {
    return !isNaN(val);
  };

  const answerComponent = (question, index) => {
    if (
      question.header !== "Financial Need" &&
      question.header !== "Self Identification Survey"
    ) {
      return (
        <Editor
          headerTemplate={header}
          name={`questionAnswer_${question.scholarship_application_answers_id}`}
          style={{ height: "155px" }}
          formats={["bold", "italic", "underline", "list"]}
          onTextChangeCustom={(e) => {
            const wordCountCopy = [...wordCount];
            wordCountCopy[index] = e.textValue.match(/\S+/g)
              ? e.textValue.match(/\S+/g).length
              : 0;
            setWordCount(wordCountCopy);
          }}
        />
      );
    } else {
      if (question.question.includes("Family")) {
        setIsFamilyCompositionPage(true);
        setFamilyCompositionKey(
          `questionAnswer_${question.scholarship_application_answers_id}`
        );
        return (
          <>
            <Dropdown
              name={`questionAnswer_${question.scholarship_application_answers_id}`}
              placeholder="Select One"
              options={familyCompositionOptions}
              autoResize="false"
              style={{ width: "100%" }}
              onChange={(e) => onFamilyCompositionChange(e, question)}
              value={
                selectedFamilyComposition === null
                  ? scholarshipAppData.data[
                      `questionAnswer_${question.scholarship_application_answers_id}`
                    ]
                  : selectedFamilyComposition
              }
            />
            {isDropDownErrorMessage ? (
              <p>
                <small className="p-invalid">
                  Please answer all questions.
                </small>
              </p>
            ) : (
              ""
            )}
          </>
        );
      } else if (question.question.includes("parent(s)/guardian(s)")) {
        if (
          selectedFamilyComposition === null &&
          scholarshipAppData.data[
            `questionAnswer_${question.scholarship_application_answers_id - 1}`
          ] === null
        ) {
          return;
        } else if (
          selectedFamilyComposition ===
            "I live in a single-parent/guardian household" ||
          scholarshipAppData.data[
            `questionAnswer_${question.scholarship_application_answers_id - 1}`
          ] === "I live in a single-parent/guardian household"
        ) {
          setFirstAnnualIncome(null);
          setSecondAnnualIncome(null);
          setAnnualIncomeKey(
            `questionAnswer_${question.scholarship_application_answers_id}`
          );
          setYouthInCare(null);
          return (
            <>
              {question.subheader && question.subheader !== null ? (
                <p className="subheader">{question.subheader}</p>
              ) : (
                ""
              )}
              <div className="p-grid">
                <div className="p-col-12">
                  <h3 style={{ marginTop: "50px" }}>{question.question}</h3>
                  {question.meta ? (
                    // eslint-disable-next-line react/no-danger
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(question.meta),
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <Label>
                    Parent/Guardian #1
                    <InputText
                      name={`questionAnswer_${question.scholarship_application_answers_id}`}
                      placeholder="Enter your Parent/Guardian #1 reported gross annual income"
                      className="p-col-12"
                      onChange={(e) => onAnnualIncomeChange(e, question)}
                      value={
                        selectedAnnualIncome === null
                          ? scholarshipAppData.data[
                              `questionAnswer_${question.scholarship_application_answers_id}`
                            ]
                          : selectedAnnualIncome
                      }
                    />
                  </Label>
                  {isErrorMessage ? (
                    <p>
                      <small className="p-invalid">
                        Please answer all questions.
                      </small>
                    </p>
                  ) : (
                    ""
                  )}
                  {isStringErrorMessage ? (
                    <p>
                      <small className="p-invalid">
                        Please enter the numeric value.
                      </small>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          );
        } else if (
          selectedFamilyComposition ===
            "I live in a two-parent/guardian household" ||
          scholarshipAppData.data[
            `questionAnswer_${question.scholarship_application_answers_id - 1}`
          ] === "I live in a two-parent/guardian household"
        ) {
          setFirstAnnualIncome(
            `questionAnswer_${question.scholarship_application_answers_id}_first`
          );
          setSecondAnnualIncome(
            `questionAnswer_${question.scholarship_application_answers_id}_second`
          );
          setAnnualIncomeKey(
            `questionAnswer_${question.scholarship_application_answers_id}`
          );
          setYouthInCare(null);
          return (
            <>
              {question.subheader && question.subheader !== null ? (
                <p className="subheader">{question.subheader}</p>
              ) : (
                ""
              )}
              <div className="p-grid">
                <div className="p-col-12">
                  <h3 style={{ marginTop: "50px" }}>{question.question}</h3>
                  {question.meta ? (
                    // eslint-disable-next-line react/no-danger
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(question.meta),
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <div style={{ marginBottom: "25px" }}>
                    <Label>
                      Parent/Guardian #1
                      <InputText
                        name={`questionAnswer_${question.scholarship_application_answers_id}_first`}
                        placeholder="Enter your Parent/Guardian #1 reported gross annual income"
                        className="p-col-12"
                        style={{ width: "100%" }}
                        onChange={(e) => onFirstAnnualIncomeChange(e, question)}
                        value={
                          selectedFirstAnnualIncome === null
                            ? scholarshipAppData.data[
                                `questionAnswer_${question.scholarship_application_answers_id}_first`
                              ]
                            : selectedFirstAnnualIncome
                        }
                      />
                    </Label>
                  </div>
                  <div>
                    <Label>
                      Parent/Guardian #2
                      <InputText
                        name={`questionAnswer_${question.scholarship_application_answers_id}_second`}
                        placeholder="Enter your Parent/Guardian #2 reported gross annual income"
                        className="p-col-12"
                        style={{ width: "100%" }}
                        onChange={(e) =>
                          onSecondAnnualIncomeChange(e, question)
                        }
                        value={
                          selectedSecondAnnualIncome === null
                            ? scholarshipAppData.data[
                                `questionAnswer_${question.scholarship_application_answers_id}_second`
                              ]
                            : selectedSecondAnnualIncome
                        }
                      />
                    </Label>
                  </div>
                  {isErrorMessage ? (
                    <p>
                      <small className="p-invalid">
                        Please answer all questions.
                      </small>
                    </p>
                  ) : (
                    ""
                  )}
                  {isStringErrorMessage ? (
                    <p>
                      <small className="p-invalid">
                        Please enter the numeric value.
                      </small>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          );
        } else {
          setFirstAnnualIncome(null);
          setSecondAnnualIncome(null);
          setYouthInCare("I am a Youth in Care, or a former Youth in Care");
          setAnnualIncomeKey(
            `questionAnswer_${question.scholarship_application_answers_id}`
          );
          return;
        }
      } else if (question.question.includes("COVID-19")) {
        return (
          <Editor
            headerTemplate={header}
            name={`questionAnswer_${question.scholarship_application_answers_id}`}
            style={{ height: "155px" }}
            formats={["bold", "italic", "underline", "list"]}
            onTextChangeCustom={(e) => {
              const wordCountCopy = [...wordCount];
              wordCountCopy[index] = e.textValue.match(/\S+/g)
                ? e.textValue.match(/\S+/g).length
                : 0;
              setWordCount(wordCountCopy);
            }}
          />
        );
      } else if (question.question.includes("how many dependents")) {
        setIsNumDependentPage(true);
        setNumDependentKey(
          `questionAnswer_${question.scholarship_application_answers_id}`
        );
        return (
          <>
            <Dropdown
              id="numberOfDependents"
              name={`questionAnswer_${question.scholarship_application_answers_id}`}
              placeholder="Select the number of dependents"
              options={numberOfDependentsOptions}
              style={{ width: "100%" }}
              onChange={(e) => {
                onNumDependentChange(e, question);
                // setNumDependentDisplay("block");
              }}
              value={
                selectedNumDependent === null
                  ? scholarshipAppData.data[
                      `questionAnswer_${question.scholarship_application_answers_id}`
                    ]
                  : selectedNumDependent
              }
            />
            {isDropDownErrorMessage ? (
              <p>
                <small className="p-invalid">
                  Please answer all questions.
                </small>
              </p>
            ) : (
              ""
            )}
          </>
        );
      } else if (question.header === "Self Identification Survey") {
        setIsMarginPage(true);

        return (
          <>
            <CheckboxPR
              id={`marginalized-group-checkbox-${question.scholarship_application_answers_id}`}
              name={question.scholarship_application_answers_id}
              className="marginalized-group-checkbox"
              value={question.scholarship_application_answers_id}
              label={question.question}
              onChange={(e) => onMarginalizedGroupChange(e)}
              checked={savedMarginalizedGroup.includes(
                question.scholarship_application_answers_id
              )}
            />
          </>
        );
      } else if (
        question.question.includes("list the birth year of each dependent")
      ) {
        if (
          selectedNumDependent === null &&
          scholarshipAppData.data[
            `questionAnswer_${question.scholarship_application_answers_id - 1}`
          ] === null
        ) {
        } else if (
          selectedNumDependent === "0" ||
          scholarshipAppData.data[
            `questionAnswer_${question.scholarship_application_answers_id - 1}`
          ] === "0"
        ) {
          numDependentKeyArr = [];
          setDependentBirthYearKey(null);
          setNoDependent(
            `questionAnswer_${question.scholarship_application_answers_id}`
          );
          question.numDependents =
            scholarshipAppData.data[
              `questionAnswer_${
                question.scholarship_application_answers_id - 1
              }`
            ];

          return (
            <>
              <p style={{ marginTop: "50px" }} className="subheader">
                {question.subheader}
              </p>
              <div className="p-grid">
                <div className="p-col-12">
                  <h3>{question.question}</h3>
                  {question.meta ? (
                    // eslint-disable-next-line react/no-danger
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(question.meta),
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <p>You selected 0 dependent. Please go to the next page.</p>
                </div>
              </div>
            </>
          );
        } else {
          let numDependentsArr = [];
          numDependentKeyArr = [];

          for (
            var i = 1;
            i <=
            parseInt(
              selectedNumDependent === null
                ? scholarshipAppData.data[
                    `questionAnswer_${
                      question.scholarship_application_answers_id - 1
                    }`
                  ]
                : selectedNumDependent,
              10
            );
            i++
          ) {
            numDependentsArr.push(i);
            numDependentKeyArr.push(`questionAnswer_dependents_year_${i}`);
          }

          setDependentBirthYearKey(
            `questionAnswer_${question.scholarship_application_answers_id}`
          );
          setNoDependent(null);

          return (
            <>
              <p style={{ marginTop: "50px" }} className="subheader">
                {question.subheader}
              </p>
              <div className="p-grid">
                <div className="p-col-12">
                  {question.question.includes(
                    "list the birth year of each dependent"
                  ) ? (
                    <h3>{question.question}</h3>
                  ) : (
                    <h3>{question.question}</h3>
                  )}
                  {question.meta ? (
                    // eslint-disable-next-line react/no-danger
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(question.meta),
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {numDependentsArr.map((numDependent, index) => (
                    <>
                      <div
                        style={{
                          marginBottom: "25px",
                        }}
                      >
                        <Label>
                          Dependent {numDependent}
                          <InputText
                            name={`questionAnswer_dependents_year_${numDependent}`}
                            placeholder={`Enter the birth year of dependent ${numDependent}`}
                            className="p-col-12"
                          />
                        </Label>
                      </div>
                      {index === numDependentsArr.length - 1 ? (
                        <div>
                          {isDependentErrorMessage ? (
                            <p>
                              <small className="p-invalid">
                                Please answer all questions.
                              </small>
                            </p>
                          ) : (
                            ""
                          )}
                          {isDependentStringErrorMessage ? (
                            <p>
                              <small className="p-invalid">
                                Please enter year(s) within 2008 - 2026 in this
                                format: YYYY (example: 2012)
                              </small>
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ))}
                </div>
              </div>
            </>
          );
        }
      }
    }
  };

  return (
    <PageWrapper>
      {steppers(pageInfo.pageNum)}

      <Formik
        initialValues={
          scholarshipAppData.isLoading
            ? initialValues(questions)
            : scholarshipAppData.data
        } // display initial values if no page data exists
        validationSchema={validationSchema(questions)}
        onSubmit={(values) => {
          if (selectedFamilyComposition !== null) {
            values[familyCompositionKey] = selectedFamilyComposition;
          }

          if (selectedAnnualIncome !== null) {
            values[annualIncomeKey] = selectedAnnualIncome;
          }

          if (selectedNumDependent !== null) {
            values[numDependentKey] = selectedNumDependent;
          }

          if (isNMarginPage) {
            // Assuming that the marginalized group page checkboxes are the only one on the page
            let inputs = document.getElementsByTagName("input");

            for (let i = 0; i < inputs.length; i++) {
              if (inputs[i].type == "checkbox") {
                let checkbox = inputs[i];
                let questionAnswer = `questionAnswer_${checkbox.name}`;
                if (checkbox.checked) {
                  values[questionAnswer] = 1;
                } else {
                  values[questionAnswer] = null;
                }
              }
            }
          }

          if (selectedFirstAnnualIncome !== null) {
            values[firstAnnualIncome] = selectedFirstAnnualIncome;
          }

          if (selectedSecondAnnualIncome !== null) {
            values[secondAnnualIncome] = selectedSecondAnnualIncome;
          }

          if (firstAnnualIncome !== null && secondAnnualIncome !== null) {
            values[annualIncomeKey] =
              values[firstAnnualIncome] + ", " + values[secondAnnualIncome];
          } else if (youthInCare !== null) {
            values[annualIncomeKey] = "0";
          }

          if (numDependentKeyArr.length !== 0 && noDependent === null) {
            numDependentKeyArr.map(
              (numDependentKey, index) =>
                (values[dependentBirthYearKey] =
                  index === 0
                    ? values[numDependentKey]
                    : values[dependentBirthYearKey] +
                      ", " +
                      values[numDependentKey])
            );
          }

          if (noDependent !== null) {
            values[noDependent] = null;
          }

          /*
            Validation for family composition, tax return values, and the number of dependents
          */
          if (
            isFamilyCompositionPage &&
            ((familyCompositionKey !== null &&
              values[familyCompositionKey] === null) ||
              (familyCompositionKey === null &&
                values[familyCompositionKey] == null))
          ) {
            setIsDropdownErrorMessage(true);
          } else if (
            familyCompositionKey !== null &&
            values[familyCompositionKey] !== null &&
            (values[annualIncomeKey] === "" || values[annualIncomeKey] === null)
          ) {
            setIsErrorMessage(true);
          } else if (
            isNumDependentPage &&
            ((numDependentKey !== null && values[numDependentKey] === null) ||
              (numDependentKey === null && values[numDependentKey] == null))
          ) {
            setIsDropdownErrorMessage(true);
          } else if (
            firstAnnualIncome !== null &&
            secondAnnualIncome !== null &&
            (values[firstAnnualIncome] === null ||
              values[firstAnnualIncome] === "" ||
              values[secondAnnualIncome] === null ||
              values[secondAnnualIncome] === "") &&
            (!isNum(values[firstAnnualIncome]) ||
              !isNum(values[secondAnnualIncome]))
          ) {
            setIsErrorMessage(true);
            setIsStringErrorMessage(true);
          } else if (
            firstAnnualIncome !== null &&
            secondAnnualIncome !== null &&
            (values[firstAnnualIncome] === null ||
              values[firstAnnualIncome] === "" ||
              values[secondAnnualIncome] === null ||
              values[secondAnnualIncome] === "") &&
            isNum(values[firstAnnualIncome]) &&
            isNum(values[secondAnnualIncome])
          ) {
            setIsErrorMessage(true);
            setIsStringErrorMessage(false);
          } else if (
            firstAnnualIncome !== null &&
            secondAnnualIncome !== null &&
            values[firstAnnualIncome] !== null &&
            values[firstAnnualIncome] !== "" &&
            values[secondAnnualIncome] !== null &&
            values[secondAnnualIncome] !== "" &&
            (!isNum(values[firstAnnualIncome]) ||
              !isNum(values[secondAnnualIncome]))
          ) {
            setIsErrorMessage(false);
            setIsStringErrorMessage(true);
          } else if (
            firstAnnualIncome !== null &&
            secondAnnualIncome !== null &&
            (!isNum(values[firstAnnualIncome]) ||
              !isNum(values[secondAnnualIncome]))
          ) {
            setIsStringErrorMessage(true);
          } else if (
            firstAnnualIncome === null &&
            secondAnnualIncome === null &&
            annualIncomeKey !== null &&
            !isNum(values[annualIncomeKey])
          ) {
            setIsStringErrorMessage(true);
          } else if (
            noDependent === null &&
            numDependentKeyArr.length !== 0 &&
            dependentBirthYearKey !== null
          ) {
            let emptyError = [];
            let notNumberError = [];
            numDependentKeyArr.map((numDependentKey) =>
              values[numDependentKey] === null ||
              values[numDependentKey] === "" ||
              values[numDependentKey] === undefined
                ? emptyError.push("emptyError")
                : !/\d/.test(values[numDependentKey]) ||
                  parseInt(values[numDependentKey], 10).toString().length !==
                    4 ||
                  parseInt(values[numDependentKey], 10) < 2008 ||
                  parseInt(values[numDependentKey], 10) > 2026
                ? notNumberError.push("notNumberError")
                : ""
            );

            if (emptyError.length !== 0 && notNumberError.length === 0) {
              setIsDependentErrorMessage(true);
              setIsDependentStringErrorMessage(false);
            }
            if (notNumberError.length !== 0 && emptyError.length === 0) {
              setIsDependentErrorMessage(false);
              setIsDependentStringErrorMessage(true);
            }
            if (notNumberError.length !== 0 && emptyError.length !== 0) {
              setIsDependentErrorMessage(true);
              setIsDependentStringErrorMessage(true);
            }
            if (emptyError.length === 0 && notNumberError.length === 0) {
              setIsStringErrorMessage(false);
              setIsErrorMessage(false);
              setIsDependentErrorMessage(false);
              setIsDependentStringErrorMessage(false);
              for (name in values) {
                if (name.startsWith("questionAnswer_dependents_year")) {
                  delete values[name];
                }
              }
              savePage(values); // should remove questionAnswers_null_dependent values
              goToPage(pageInfo.pageNum + 1);
              window.scrollTo(0, 0);
            }
          } else {
            setIsDropdownErrorMessage(false);
            setIsStringErrorMessage(false);
            setIsErrorMessage(false);
            for (name in values) {
              if (name.startsWith("questionAnswer_dependents_year")) {
                delete values[name];
              }
            }
            savePage(values);
            setIsDependentErrorMessage(false);
            setIsDependentStringErrorMessage(false);

            goToPage(pageInfo.pageNum + 1);
            window.scrollTo(0, 0);
          }
        }}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div className="p-grid">
              {!spinnerStatus ? autoSave : ""}
              {questions[0].header !== "Self Identification Survey" ? (
                <div className="p-col-12">
                  <h1>{questions[0].header}</h1>
                </div>
              ) : (
                ""
              )}

              {questions[0].header === "Self Identification Survey" ? (
                <>
                  <div className="p-col-12">
                    <h1>{questions[0].header}</h1>
                  </div>
                  <div className="p-col-12 questions-container">
                    <p className="subheader">{questions[0].subheader}</p>
                    <br></br>
                    <br></br>
                    {questions.map((questions, index) => (
                      <div>
                        {answerComponent(questions, index)}
                        <br></br>
                        <br></br>
                        <br></br>
                      </div>
                    ))}
                    <br />
                    <p>
                      If you have any questions or concerns about this
                      disclosure, please do not hesitate to contact the Uggla
                      Family Scholarship Program Manager at{" "}
                      <a
                        href="mailto:sfu_uggla_scholars@sfu.ca"
                        target="_blank"
                        rel="noreferrer"
                      >
                        sfu_uggla_scholars@sfu.ca
                      </a>
                      .
                    </p>
                  </div>
                </>
              ) : (
                <div className="p-col-12 questions-container">
                  {questions.map((question, index) => (
                    <div
                      key={`questionAnswer_${question.scholarship_application_answers_id}`}
                    >
                      {question.question.includes("parent(s)/guardian(s)") ||
                      question.question.includes(
                        "list the birth year of each dependent"
                      ) ? (
                        ""
                      ) : (
                        <p className="subheader">{questions[0].subheader}</p>
                      )}
                      <div className="p-grid">
                        <div className="p-col-12">
                          {question.question.includes(
                            "parent(s)/guardian(s)"
                          ) ||
                          question.question.includes(
                            "list the birth year of each dependent"
                          ) ? (
                            ""
                          ) : (
                            <>
                              <h3>
                                {question.question}{" "}
                                {question.word_limit && question.word_limit > 0
                                  ? ` (${question.word_limit} words max.)`
                                  : ""}
                              </h3>
                              {question.meta ? (
                                // eslint-disable-next-line react/no-danger
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizer(question.meta),
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </>
                          )}

                          {answerComponent(question, index)}

                          <span className="push-right word-limit-count">
                            {question.word_limit && question.word_limit > 0
                              ? `${wordCount[index]} / ${question.word_limit} Words`
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                  <span className="last-saved">
                    <em>{lastSaved}</em>
                  </span>
                </div>
              )}
            </div>
            <div className="p-grid button-navigation-container">
              <div className="p-col-12">
                {pageInfo.pageNum === 1 ? (
                  ""
                ) : (
                  <PrimaryButton
                    type="button"
                    onClick={() => {
                      for (name in formik.values) {
                        if (name.startsWith("questionAnswer_dependents_year")) {
                          delete formik.values[name];
                        }
                      }
                      savePage(formik.values);
                      goToPage(pageInfo.pageNum - 1);
                    }}
                  >
                    Back
                  </PrimaryButton>
                )}
                <PrimaryButton
                  type="submit"
                  className="push-right"
                  disabled={spinnerStatus}
                >
                  Next
                </PrimaryButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
